import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PageEvent } from '@angular/material/paginator';
import { ToastrService } from 'ngx-toastr';
import { Subscription, interval } from 'rxjs';
import { ToasterMessages } from 'src/app/shared/constants/constants';
import {
  getMonthlyConditionOptions,
  getSegmentOptions,
  getmonths,
} from 'src/app/shared/helpers/Drop-down-options';
import { MonthlyReportService } from 'src/app/shared/service/monthly-report.service';
import { OverlapService } from 'src/app/shared/service/overlapService/overlap.service';
import { RequestFormService } from 'src/app/shared/service/requestForm/request-form.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-generate-report',
  templateUrl: './generate-report.component.html',
  styleUrls: ['./generate-report.component.scss'],
})
export class GenerateReportComponent {
  addRowdData: any[] = [];
  rowData: any = {};
  conditionOptions: any;
  paginatedData: any[] = [];
  itemsPerPage: number = 100;
  currentPage: number = 0;
  filterForm!: FormGroup;
  segmentOptions: any;
  tableData: any[] = [];
  selectedTab: boolean;
  addRowBtn: boolean = true;
  generateReport: boolean = false;
  monthoptions: any;
  private refreshSubscription!: Subscription;
  username: any;
  clientOptions: any;
  subusername: any;
isLoadingTable: boolean = false;
  constructor(
    private toastr: ToastrService,
    private fb: FormBuilder,
    private requestFormService: RequestFormService,
    private monthlyReportService: MonthlyReportService,
    private overlayService: OverlapService
  ) {
    this.selectedTab = true;
    this.filterForm = this.fb.group({
      from_date: ['', [Validators.required]],
      to_date: ['', [Validators.required]],
      segment: ['', [Validators.required]],
      condition: [''],
    });
    this.segmentOptions = getSegmentOptions();
    this.monthoptions = getmonths();
    this.conditionOptions = getMonthlyConditionOptions();
  }

  isClientMatch(customer: string, username: string): boolean {
    if (!customer || !username) return false;
    const c = customer.trim().toLowerCase();
    const u = username.trim().toLowerCase();
    if (c === u) return true;
    const mapping = ['eiger', 'elite', 'alcor', 'emz', 'ethiopian', 'zeronorth'];
    for (const key of mapping) {
      if (c.includes(key) && u.includes(key)) {
        return true;
      }
    }
    return false;
  }

  ngOnInit() {
    this.username = localStorage.getItem('username');
    this.subusername = localStorage.getItem('loginPic');
    this.selectedTab = true;
    if (this.subusername?.toLowerCase() === 'grace') {
      this.segmentOptions = ['Suezmax', 'LR3/Suezmax'];
    } else {
      this.segmentOptions = getSegmentOptions();
    }
    if (this.username !== 'Eiger Shipping') {
      this.getData();
    }
    this.loadClients();
  }
  loadClients(){
    this.requestFormService.getClientList().subscribe((res:any) =>{
       this.clientOptions = res.map((client:any) => client.client_name);
    })
  }
  refresh() {
    if (this.username !== 'Eiger Shipping') {
      this.getData();
    }
    this.clearClick();
  }
  getData() {
    this.isLoadingTable = true;
    this.monthlyReportService.getReportDetails().subscribe((data: any) => {
      let custom = (data || []).filter(
        (item: any) => item.report_type === 'custom'
      );

      if (this.username === 'Meraki - Operations') {
        this.tableData = custom;
      } else {
        this.tableData = custom.filter(
          (item: any) =>
            this.isClientMatch(item.customer, this.username) ||
            item.customer === this.username
        );
      }

      // Grace user restriction: Suezmax only
      if (this.subusername?.toLowerCase() === 'grace') {
        this.tableData = this.tableData.filter((item: any) =>
          (item.segment || '').toLowerCase().includes('suezmax')
        );
        this.segmentOptions = Array.from(
          new Set(this.tableData.map((item: any) => item.segment).filter(Boolean))
        );
        if (this.segmentOptions.length === 0) {
          this.segmentOptions = ['Suezmax', 'LR3/Suezmax'];
        }
      }

      this.paginateData();
      this.isLoadingTable = false;
    });
  }
  ngOnDestroy() {
    if (this.refreshSubscription) {
      this.refreshSubscription.unsubscribe();
    }
  }
  addRow() {
    const newRowSNo = this.paginatedData.length + 1;
    this.addRowdData.push({ sNo: newRowSNo });
    this.addRowBtn = false;
    this.generateReport = true;
  }
  paginateData() {
    const startIndex = this.currentPage * this.itemsPerPage;
    this.paginatedData = this.tableData.slice(
      startIndex,
      startIndex + this.itemsPerPage
    );
  }
  onPageChange(event: PageEvent) {
    this.currentPage = event.pageIndex;
    this.itemsPerPage = event.pageSize;
    this.paginateData();
  }
  isDarkMode() {
    return this.requestFormService.isDarkMode();
  }
  filterClick() {
    const from_date_str = this.filterForm.get('from_date')?.value;
    const to_date_str = this.filterForm.get('to_date')?.value;
    const segment = this.filterForm.get('segment')?.value;
    const condition = this.filterForm.get('condition')?.value;

    const filteredData = this.tableData.filter((element) => {
      const fromDateValid =
        !from_date_str || element.from_date >= from_date_str;
      const toDateValid = !to_date_str || element.to_date <= to_date_str;
      const segmentValid =
        !segment || element.segment?.toLowerCase() === segment.toLowerCase();
      const conditionValid =
        !condition ||
        element.vessel_condition?.toLowerCase() === condition.toLowerCase();

      return fromDateValid && toDateValid && segmentValid && conditionValid;
    });
    this.paginatedData = filteredData;
    console.log(filteredData);
  }
  clearClick() {
    this.filterForm.reset();
   if (this.username !== 'Eiger Shipping') {
      this.getData();
    }
  }
  pdfData: any;
  showDetails(row: any) {
    const baseUrl: string = environment.apiBaseUrl || window.location.origin;
    if (row.pdf_link) {
      this.pdfData = row.pdf_link;

      if (this.pdfData) {
        const fullUrl = baseUrl + this.pdfData;
        this.toastr.success(ToasterMessages.PdfProcessing);
        fetch(fullUrl)
          .then((response) => response.blob())
          .then((blob) => {
            this.overlayService.showPdf(blob);
            this.toastr.clear();
          })
          .catch((error) => {
            console.error('Error fetching PDF data:', error);
          });
      }
    } else {
      this.toastr.info('PDF  not available');
    }
  }
  generate(row: any) {
    let payload = {
      from: row.from,
      to: row.to,
      segment: row.segment,
      condition: row.condition,
      report_type: 'custom',
      customer: row.client,
    };

    this.monthlyReportService.generateReport(payload).subscribe(
      (data: any) => {},
      (error) => {
        if (error.error.text === 'Responding: Process Triggered...') {
          this.toastr.success(ToasterMessages.MonthlyReportGenaration);
          this.clearClick();
          this.generateReport = false;
          this.addRowdData = [];
          this.getData();
        } else {
          this.toastr.error(ToasterMessages.Error);
        }
      }
    );

    this.addRowBtn = true;

    // else if (monthsDiff > 6 || (monthsDiff === 6 && daysDiff > 0)) {
    //   this.toastr.error('The report to be generated for only six months');
    // }
  }
  private segmentColorMap: { [key: string]: string } = {
    mr: '#c27036',
    handymax: '#369047',
    suezmax: '#6a6a6a',
    vlcc: '#3249d4',
    aframax: '#7e3b3b',
    'gas tanker': '#5b5418',
    handy: '#35707b',
    lr1: '#2a644f',
    lr2: '#556ba6',
    coaster: '#859914ff',
    handysize: '#541e85',
    supramax: '#6b181f',
    ultramax: '#85501c',
    panamax: '#723768',
    kamsarmax: '#077c5f',
    'ultra panamax': '',
    capesize: '#7c7440',
    chinamax: '',
    'lr1/panamax': '#42bfaaff',
    'lr2/aframax': '#427ebf',
    'lr3/suezmax': '#bf4281ff',
  };

  getDynamicSegmentStyle(segment: string): any {
    if (!segment) return {};

    const key = segment.toLowerCase();

    // If NOT in static mapping → assign dynamic color
    if (!this.segmentColorMap[key]) {
      this.segmentColorMap[key] = this.generateDarkColorFromText(key);
    }

    const color = this.segmentColorMap[key];

    return {
      'background-color': color,
      'border-radius': '12px',
      padding: '0px 6px',
      color: '#fff',
      display: 'inline-block',
      'font-weight': '500',
      'text-transform': 'uppercase',
      'font-size': '12px',
      'letter-spacing': '0.5px',
    };
  }

  /** Generates a consistent dark color for unknown segments */
  private generateDarkColorFromText(text: string): string {
    let hash = 0;
    for (let i = 0; i < text.length; i++) {
      hash = text.charCodeAt(i) + ((hash << 5) - hash);
    }

    let r = (hash >> 16) & 0xff;
    let g = (hash >> 8) & 0xff;
    let b = hash & 0xff;

    // Force dark tones
    r = Math.floor(r * 0.4);
    g = Math.floor(g * 0.4);
    b = Math.floor(b * 0.4);

    return `rgb(${r}, ${g}, ${b})`;
  }
}
